/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import toastr from 'toastr';
import { Base64 } from 'js-base64';
import { FaTrashAlt } from 'react-icons/fa';
import {
  Form,
  Row,
  Col,
  Input,
  Label,
  FormGroup,
} from 'reactstrap';


import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import ImageZoom from 'react-medium-image-zoom';

import SweetAlert from 'react-bootstrap-sweetalert';
import ColorInput from '../components/forms/ColorInput';
import { IMG_URL } from '../config';
import EscapeChars from '../helpers/regex';
import Content from '../components/layout/Content';
import SnipperButton from '../components/buttons/SpinnerButton';

import {
  updateSettings, getSettings, deleteLogo, defaultTheme,
} from '../api/settings';
import Loading from '../components/Loading';


class AddUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitHandle = this.submitHandle.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      spinnerLoading: false,
      settingsLoading: false,
      sweetAlert: false,
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const data = await getSettings({ masterUser });
    const { settings, themeSettings } = data.data;
    this.setState({
      theme: settings.theme,
      settings: themeSettings,
      masterUser,
    });
  }

  async deleteLogoHandler(logotype) {
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const res = await deleteLogo(masterUser, logotype).then((result) => {
      console.log('result', result);
    }, (error) => {
      console.log('error', error);
      console.log(error.response);
    }).catch((error) => {
      console.log('catch error', error);
    });
    this.setState({ imageUrl: '' });
    toastr.success('', 'Logo Deleted');
  }

  async submitHandle() {
    this.setState({ spinnerLoading: true });
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const formData = new FormData();
    const { theme, settings } = this.state;
    formData.append('theme', theme);
    formData.append('masterUser', masterUser);
    formData.append('themeSettings', JSON.stringify(settings));
    const imagefile = document.querySelector('#backgroundImage');
    const logofile = document.querySelector('#headerLogo');
    if (imagefile !== null) { // CHANGED TO AVOID ERROR!
      console.log('IMAGE', { imagefile });
      if (imagefile.files[0] !== undefined) {
        formData.append('image', imagefile.files[0], EscapeChars(imagefile.files[0].name));
      }
    }
    if (logofile !== null) {
      console.log('LOGO', { logofile });
      if (logofile.files[0] !== undefined) {
        formData.append('headerLogo', logofile.files[0], EscapeChars(logofile.files[0].name));
      }
    }
    await updateSettings(masterUser, formData);
    // imagefile.value = ''; ERROR !!!
    this.setState({ spinnerLoading: false });
    toastr.success('', 'Settings Saved');
  }

  async handleClick(theme) {
    this.setState({ theme });
    const { user } = this.props;
    //const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    this.setState({ settingsLoading: true });
    const data = await getSettings({ masterUser, theme });
    const { themeSettings } = data.data;
    this.setState({
      settingsLoading: false,
      settings: themeSettings,
      theme,
    });
  }

  handleChange(value, name, key) {
    const { settings } = this.state;
    settings[key][name] = value;
    this.setState({ settings });
  }

  async deleteHandler(logotype) {
    const { masterUser, settings } = this.state;

    const res = await deleteLogo(masterUser, logotype);
    if (logotype === 'headerLogo') settings.navigation.headerLogo = '';
    else if (logotype === 'bodyImage') settings.body.bodyImage = '';

    this.setState({ settings });
    toastr.success('', 'Image deleted');
  }

  restoreDefault = async () => {
    const { intl } = this.props;
    const restoredDef = intl.formatMessage({ id: 'restore.default.success' });
    const error = intl.formatMessage({ id: 'error' });
    this.setState({ sweetAlert: false });
    console.log('this.props', this.props);
    const { masterUser } = this.state;
    console.log('user', { masterUser });
    await defaultTheme(masterUser).then((result) => {
      toastr.success(restoredDef);
    }, (error) => {
      console.log('error', error);
      toastr.error(error);
    });
  }

  render() {
    const { intl } = this.props;
    const {
      spinnerLoading, theme, settings, settingsLoading, masterUser, sweetAlert,
    } = this.state;
    const rowCountOptions = [];
    const screenPaddingOptions = [];
    const childPaddingOptions = [];
    const fontSizeOptions = [];


    if (settings) {
      for (let i = 1; i <= 10; i += 1) {
        rowCountOptions.push(<option key={i} value={i}>{i}</option>);
      }
      for (let i = 10; i <= 100; i += 10) {
        screenPaddingOptions.push(<option key={i} value={i}>{i}</option>);
      }
      for (let i = 5; i <= 50; i += 5) {
        childPaddingOptions.push(<option key={i} value={i}>{i}</option>);
      }
      for (let i = 12; i <= 72; i++) {
        fontSizeOptions.push(<option key={i} value={i}>{i}</option>);
      }
    }


    const themeSettings = intl.formatMessage({ id: 'themeSettings' });
    const bodySettings = intl.formatMessage({ id: 'themeSettings.bodySettings' });
    const backgroundType = intl.formatMessage({ id: 'themeSettings.backgroundType' });
    const backgroundImageText = intl.formatMessage({ id: 'themeSettings.backgroundImageText' });
    const backgroundColorText = intl.formatMessage({ id: 'background.color' });
    const textColor = intl.formatMessage({ id: 'text.color' });
    const others = intl.formatMessage({ id: 'themeSettings.others' });
    const headerLogo = intl.formatMessage({ id: 'themeSettings.headerLogo' });
    const categorySettings = intl.formatMessage({ id: 'themeSettings.categorySettings' });
    const categoryRowCount = intl.formatMessage({ id: 'themeSettings.categoryRowCount' });
    const categoryFontSize = intl.formatMessage({ id: 'themeSettings.categoryFontSize' });
    const categoryPadding = intl.formatMessage({ id: 'themeSettings.categoryPadding' });
    const productSettings = intl.formatMessage({ id: 'themeSettings.productSettings' });
    const productRowCount = intl.formatMessage({ id: 'themeSettings.productRowCount' });
    const productLineRowCount = intl.formatMessage({ id: 'themeSettings.productLineRowCount' });
    const productFontSize = intl.formatMessage({ id: 'themeSettings.productFontSize' });
    const screenPadding = intl.formatMessage({ id: 'themeSettings.screenPadding' });
    const productPadding = intl.formatMessage({ id: 'themeSettings.productPadding' });
    const renderStyle = intl.formatMessage({ id: 'themeSettings.renderStyle' });
    const renderLine = intl.formatMessage({ id: 'themeSettings.renderLine' });
    const renderBlocks = intl.formatMessage({ id: 'themeSettings.renderBlocks' });
    const imageText = intl.formatMessage({ id: 'image' });
    const colorText = intl.formatMessage({ id: 'color' });
    const slideDelay = intl.formatMessage({ id: 'themeSettings.slideDelay' });
    const themeText = intl.formatMessage({ id: 'theme' });
    const saveText = intl.formatMessage({ id: 'save' });
    const entityBackgroundColorText = intl.formatMessage({ id: 'entityBackgroundColorText' });
    const entityTextColorText = intl.formatMessage({ id: 'entityTextColorText' });
    const headerColorText = intl.formatMessage({ id: 'themeSettings.headerColor' });
    const productTitleText = intl.formatMessage({ id: 'themeSettings.productTitle' });
    const restoreDefaultText = intl.formatMessage({ id: 'restore.default' });

    const confirmText = intl.formatMessage({ id: 'confirm' });
    const areYouSureText = intl.formatMessage({ id: 'areyousure' });
    const cancelText = intl.formatMessage({ id: 'cancel' });

    return (
      <Row>
        <Col>
          <Formik
            enableReinitialize
            onSubmit={this.submitHandle}
          >
            {({
              errors,
              handleSubmit,
              /* and other goodies */
            }) => (
                <Content title={themeSettings} theme onClick={() => this.setState({ sweetAlert: true })} text={restoreDefaultText}>
                  {
                    !settings ? <Loading />
                      : (
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                          <Row>
                            <Col md="2">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="radio"
                                    name="theme"
                                    value=""
                                    defaultChecked={parseInt(theme, 10) === 1 ? 'checked' : ''}
                                    onClick={() => this.handleClick(1)}
                                  />
                                  {' '}
                                  {themeText}
                                  {' '}
                                  1
                                </Label>
                                <ImageZoom
                                  image={{
                                    src: 'https://themeshaper.files.wordpress.com/2013/10/theme-shaper-cloud1.png',
                                    alt: 'Golden Gate Bridge',
                                    className: 'img',
                                    style: { width: '200px' },
                                  }}
                                  zoomImage={{
                                    src: 'https://themeshaper.files.wordpress.com/2013/10/theme-shaper-cloud1.png',
                                    alt: 'Golden Gate Bridge',
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="radio"
                                    name="theme"
                                    value=""
                                    defaultChecked={parseInt(theme, 10) === 2 ? 'checked' : ''}
                                    onClick={() => this.handleClick(2)}
                                  />
                                  {' '}
                                  {themeText}
                                  {' '}
                                  2
                                </Label>
                                <ImageZoom
                                  image={{
                                    src: 'https://themeshaper.files.wordpress.com/2013/10/theme-shaper-cloud1.png',
                                    alt: 'Golden Gate Bridge',
                                    className: 'img',
                                    style: { width: '200px' },
                                  }}
                                  zoomImage={{
                                    src: 'https://themeshaper.files.wordpress.com/2013/10/theme-shaper-cloud1.png',
                                    alt: 'Golden Gate Bridge',
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="radio"
                                    name="theme"
                                    value=""
                                    defaultChecked={parseInt(theme, 10) === 3 ? 'checked' : ''}
                                    onClick={() => this.handleClick(3)}
                                  />
                                  {' '}
                                  {themeText}
                                  {' '}
                                  3
                                </Label>
                                <ImageZoom
                                  image={{
                                    src: 'https://themeshaper.files.wordpress.com/2013/10/theme-shaper-cloud1.png',
                                    alt: 'Golden Gate Bridge',
                                    className: 'img',
                                    style: { width: '200px' },
                                  }}
                                  zoomImage={{
                                    src: 'https://themeshaper.files.wordpress.com/2013/10/theme-shaper-cloud1.png',
                                    alt: 'Golden Gate Bridge',
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          {
                            settingsLoading ? <Loading />
                              : (
                                <Row>
                                  <Col md="6">
                                    <Title>{bodySettings}</Title>
                                    <hr />
                                    <ColorInput
                                      id="headerColor"
                                      name="headerColor"
                                      placeholder={headerColorText}
                                      type="text"
                                      label={headerColorText}
                                      onChange={(value, name) => this.handleChange(value, name, 'body')}
                                      value={settings.body.headerColor}
                                      color=""
                                    />
                                    <FormGroup tag="fieldset">
                                      <Label>{backgroundType}</Label>
                                      <FormGroup check>
                                        <Label check>
                                          <Input
                                            type="radio"
                                            name="hasBodyBackgroundImage"
                                            defaultChecked={settings.body.hasBodyBackgroundImage ? 'checked' : ''}
                                            onChange={() => this.handleChange(true, 'hasBodyBackgroundImage', 'body')}
                                          />
                                          {' '}
                                          {imageText}
                                        </Label>
                                      </FormGroup>
                                      <FormGroup check>
                                        <Label check>
                                          <Input
                                            type="radio"
                                            name="hasBodyBackgroundImage"
                                            defaultChecked={!settings.body.hasBodyBackgroundImage ? 'checked' : ''}
                                            onChange={() => this.handleChange(false, 'hasBodyBackgroundImage', 'body')}
                                          />
                                          {' '}
                                          {colorText}
                                        </Label>
                                      </FormGroup>
                                    </FormGroup>
                                    {
                                      settings.body.hasBodyBackgroundImage ? (
                                        <FormGroup>
                                          <Label for="exampleFile">{backgroundImageText}</Label>
                                          <Input
                                            type="file"
                                            name="backgroundImage"
                                            id="backgroundImage"
                                            onChange={(event) => {
                                              const output = document.getElementById('previewImage');
                                              output.style.display = 'block';

                                              output.src = URL.createObjectURL(event.target.files[0]);
                                            }}
                                          />
                                          <ImageWrapper>
                                            <ImageZoom
                                              image={{
                                                src: settings.body.bodyImage && `${IMG_URL}${Base64.encode(masterUser)}/images/${settings.body.bodyImage}`,
                                                className: 'img',
                                                id: 'previewImage',
                                                style: {
                                                  width: '200px', height: '200px', marginTop: '10px', display: settings.body.bodyImage ? 'block' : 'none',
                                                },
                                              }}
                                              zoomImage={{
                                                src: settings.body.bodyImage && `${IMG_URL}${Base64.encode(masterUser)}/images/${settings.body.bodyImage}`,
                                              }}
                                            />
                                            {settings.body.bodyImage && <DeleteButton onClick={() => this.deleteHandler('bodyImage')} />}
                                          </ImageWrapper>
                                        </FormGroup>
                                      ) : ''
                                    }
                                    <ColorInput
                                      id="bodyBackground"
                                      name="bodyBackground"
                                      placeholder="Body Background Color"
                                      type="text"
                                      label={backgroundColorText}
                                      onChange={(value, name) => this.handleChange(value, name, 'body')}
                                      value={settings.body.bodyBackground}
                                      color=""
                                    />
                                    <ColorInput
                                      id="color"
                                      placeholder="Body Text Color"
                                      name="bodyColor"
                                      type="text"
                                      label={textColor}
                                      onChange={(value, name) => this.handleChange(value, name, 'body')}
                                      value={settings.body.bodyColor}
                                      color=""
                                    />
                                  </Col>
                                  <Col md="6">
                                    <Title>{others}</Title>
                                    <hr />
                                    <FormGroup>
                                      <Label for="exampleSelect">{slideDelay}</Label>
                                      <Input
                                        type="select"
                                        name="delay"
                                        id="delay"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'navigation')}
                                        defaultValue={settings.navigation.delay}
                                      >
                                        {screenPaddingOptions}
                                      </Input>
                                    </FormGroup>
                                    <ColorInput
                                      id="entityBackgroundColor"
                                      name="entityBackgroundColor"
                                      placeholder="Entity Background Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'navigation')}
                                      label={entityBackgroundColorText}
                                      value={settings.navigation.entityBackgroundColor}
                                      color=""
                                    />
                                    <ColorInput
                                      id="entityTextColor"
                                      name="entityTextColor"
                                      placeholder="Entity Text Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'navigation')}
                                      label={entityTextColorText}
                                      value={settings.navigation.entityTextColor}
                                      color=""
                                    />
                                    <FormGroup>
                                      <Label for="exampleFile">{headerLogo}</Label>
                                      <Input
                                        type="file"
                                        name="headerLogo"
                                        id="headerLogo"
                                        onChange={(event) => {
                                          const output = document.getElementById('preHeaderLogo');
                                          output.style.display = 'block';

                                          output.src = URL.createObjectURL(event.target.files[0]);
                                        }}
                                      />
                                      <ImageWrapper>
                                        <ImageZoom
                                          image={{
                                            src: settings.navigation.headerLogo && `${IMG_URL}${Base64.encode(masterUser)}/images/${settings.navigation.headerLogo}`,
                                            className: 'img',
                                            id: 'preHeaderLogo',
                                            style: {
                                              width: '300px', height: '200px', marginTop: '10px', display: settings.navigation.headerLogo ? 'block' : 'none',
                                            },
                                          }}
                                          zoomImage={{
                                            src: settings.navigation.headerLogo && `${IMG_URL}${Base64.encode(masterUser)}/images/${settings.navigation.headerLogo}`,
                                          }}
                                        />
                                        {settings.navigation.headerLogo && <DeleteButton onClick={() => this.deleteHandler('headerLogo')} />}
                                      </ImageWrapper>
                                    </FormGroup>
                                  </Col>
                                  <Col md="6">
                                    <Title>{categorySettings}</Title>
                                    <hr />
                                    <FormGroup>
                                      <Label for="exampleSelect">{categoryRowCount}</Label>
                                      <Input
                                        type="select"
                                        name="rowItemCount"
                                        id="rowItemCount"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'slider')}
                                        defaultValue={settings.slider.rowItemCount}
                                      >
                                        {
                                          rowCountOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{categoryFontSize}</Label>
                                      <Input
                                        type="select"
                                        name="categoryFontSize"
                                        id="categoryFontSize"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'slider')}
                                        defaultValue={settings.slider.categoryFontSize}
                                      >
                                        {
                                          fontSizeOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{screenPadding}</Label>
                                      <Input
                                        type="select"
                                        name="screenPadding"
                                        id="screenPadding"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'slider')}
                                        defaultValue={settings.slider.screenPadding}
                                      >
                                        {
                                          screenPaddingOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{categoryPadding}</Label>
                                      <Input
                                        type="select"
                                        name="childPadding"
                                        id="childPadding"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'slider')}
                                        defaultValue={settings.slider.childPadding}
                                      >
                                        {
                                          childPaddingOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <ColorInput
                                      id="sliderItemColor"
                                      name="sliderItemColor"
                                      placeholder="Slider Background Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'slider')}
                                      label={backgroundColorText}
                                      value={settings.slider.sliderItemColor}
                                      color=""
                                    />
                                    <ColorInput
                                      id="textColor"
                                      name="sliderTextColor"
                                      placeholder="Slider Text Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'slider')}
                                      label={textColor}
                                      value={settings.slider.sliderTextColor}
                                      color=""
                                    />
                                  </Col>
                                  <Col md="6">
                                    <Title>{productSettings}</Title>
                                    <hr />
                                    <FormGroup>
                                      <Label for="exampleSelect">{productRowCount}</Label>
                                      <Input
                                        type="select"
                                        name="productRowItemCount"
                                        id="productRowItemCount"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'productList')}
                                        defaultValue={settings.productList.productRowItemCount}
                                      >
                                        {
                                          rowCountOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{productLineRowCount}</Label>
                                      <Input
                                        type="select"
                                        name="productLineRowItemCount"
                                        id="productLineRowItemCount"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'productList')}
                                        defaultValue={settings.productList.productLineRowItemCount}
                                      >
                                        {
                                          rowCountOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{productFontSize}</Label>
                                      <Input
                                        type="select"
                                        name="productFontSize"
                                        id="productFontSize"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'productList')}
                                        defaultValue={settings.productList.productFontSize}
                                      >
                                        {
                                          fontSizeOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{renderStyle}</Label>
                                      <Input
                                        type="select"
                                        name="renderStyle"
                                        id="renderStyle"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'productList')}
                                        defaultValue={settings.productList.renderStyle}
                                      >
                                        <option value="blocks">{renderBlocks}</option>
                                        <option value="lines">{renderLine}</option>
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{screenPadding}</Label>
                                      <Input
                                        type="select"
                                        name="screenPadding"
                                        id="screenPadding"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'productList')}
                                        defaultValue={settings.productList.screenPadding}
                                      >
                                        {
                                          screenPaddingOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label for="exampleSelect">{productPadding}</Label>
                                      <Input
                                        type="select"
                                        name="childPadding"
                                        id="childPadding"
                                        onChange={(e) => this.handleChange(e.target.value, e.target.name, 'productList')}
                                        defaultValue={settings.productList.childPadding}
                                      >
                                        {
                                          childPaddingOptions
                                        }
                                      </Input>
                                    </FormGroup>
                                    <ColorInput
                                      id="productItemColor"
                                      name="productItemColor"
                                      placeholder="Product Background Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'productList')}
                                      label={backgroundColorText}
                                      value={settings.productList.productItemColor}
                                      color=""
                                    />
                                    <ColorInput
                                      id="productTextColor"
                                      name="productTextColor"
                                      placeholder="Product Text Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'productList')}
                                      label={textColor}
                                      value={settings.productList.productTextColor}
                                      color=""
                                    />
                                    <ColorInput
                                      id="productTitleColor"
                                      name="productTitleColor"
                                      placeholder="Product Title Color"
                                      type="text"
                                      onChange={(value, name) => this.handleChange(value, name, 'productList')}
                                      label={productTitleText}
                                      value={settings.productList.productTitleColor}
                                      color=""
                                    />
                                  </Col>

                                </Row>
                              )
                          }
                          <ButtonWrapper>
                            <SnipperButton type="submit" loading={spinnerLoading} text={saveText} />
                          </ButtonWrapper>
                        </form>
                      )
                  }
                </Content>
              )}
          </Formik>
        </Col>
        <SweetAlert
          show={sweetAlert}
          warning
          showCancel
          cancelBtnText={cancelText}
          confirmBtnText={confirmText}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          title={areYouSureText}
          onConfirm={this.restoreDefault}
          onCancel={() => this.setState({ sweetAlert: false })}
        />
      </Row>
    );
  }
}
const ButtonWrapper = styled.div`
  margin-top: 20px;
`;
const Title = styled.h3`
  padding-top: 20px;
  font-size: 1.5rem;
`;
const DeleteButton = styled(FaTrashAlt)`
  position: absolute;
  top: 10px; 
  right: -30px;
  cursor: pointer;
`;
const ImageWrapper = styled.div`
  display: inline-block;
  position: relative;
  margin-top: 40px;

`;
const mapStateToProps = (state) => ({ user: state.auth.user });
export default injectIntl(connect(mapStateToProps)(AddUserForm));
